/* Sound Connection fit guide estimate builder. Prices and variants resolved at selection and checkout. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.estimateReady) return;
    root.dataset.estimateReady = 'true';
    var results = root.querySelector('[data-pb-results]');
    var panel = root.querySelector('[data-pb-estimate]');
    if (!results || !panel) return;
    var year = root.querySelector('[data-pb-year]');
    var make = root.querySelector('[data-pb-make]');
    var model = root.querySelector('[data-pb-model]');
    var lines = panel.querySelector('[data-estimate-lines]');
    var total = panel.querySelector('[data-estimate-total]');
    var count = panel.querySelector('[data-estimate-count]');
    var message = panel.querySelector('[data-estimate-message]');
    var cartButton = panel.querySelector('[data-estimate-cart]');
    var quoteButton = panel.querySelector('[data-estimate-quote]');
    var quote = panel.querySelector('[data-estimate-form]');
    var selected = new Map();
    var retailPrices = {};
    function retailPrice(sku) { var p=retailPrices[sku];return Number.isInteger(p)&&p>0?p:null; }
    var cache = new Map();
    var busy = false;
    var revision = 0;
    panel.open = !window.matchMedia('(max-width: 760px)').matches;
    var activeVehicle = vehicle();
    var storageKey = 'soundConnectionFullFitEstimateV1';
    var bootSavedEstimate;try{bootSavedEstimate=sessionStorage.getItem(storageKey);}catch(e){}
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currency = root.dataset.currency || 'USD';
    function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:currency}).format(cents / 100); }
    function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]; }); }
    function vehicle() { return [year.value, make.value, model.value].filter(Boolean).join(' '); }
    function validVehicle() { return !!(year.value && make.value && model.value); }
    function normalize(value) { return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g,''); }
    function productPath(url) {
      var parsed = new URL(url, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^/]+)/);
      if (!match) throw new Error('Product link unavailable');
      return route + 'products/' + match[1] + '.js';
    }
    async function load(url, fresh) {
      var path = productPath(url);
      if (fresh) cache.delete(path);
      if (!cache.has(path)) cache.set(path, fetch(path, {credentials:'same-origin',cache:fresh?'no-store':'default'}).then(function (r) { if (!r.ok) throw new Error('Unable to check product'); return r.json(); }).catch(function (error) { cache.delete(path); throw error; }));
      return cache.get(path);
    }
    function save() {
      revision += 1;
      try { sessionStorage.setItem(storageKey, JSON.stringify({vehicle:activeVehicle,items:Array.from(selected.values())})); } catch (error) {}
    }
    function stateMessage(text) { message.textContent = text; }
    function buildQuote() {
      var body = 'Installed estimate request\nVehicle: ' + activeVehicle + '\n\n';
      selected.forEach(function (item) {
        body += item.quantity + ' x ' + item.title + ' (' + item.sku + ') — ' + item.location + ' — ' + (item.price === null ? 'Price to confirm' : money(item.price * item.quantity)) + '\n';
        if (item.notes) body += 'Fitment notes: ' + item.notes + '\n';
        body += item.url + '\n\n';
      });
      var subtotal = Array.from(selected.values()).reduce(function (sum, item) {return sum + item.price * item.quantity;}, 0);
      body += 'Parts subtotal: ' + money(subtotal) + '\nInstallation, tax and shipping not included. Please verify factory audio package.\n';
      var store = quote.querySelector('[data-estimate-store]');
      var notes = quote.querySelector('[data-estimate-customer-notes]');
      var audio = root.querySelector('[data-sc-audio]');
      var retained = root.querySelector('[data-sc-retain]');
      var details = root.querySelector('[data-sc-details]');
      body += 'Factory audio: ' + (audio ? audio.value : '') + '\nUpgrade preferences: ' + (retained ? retained.value : '') + '\nBody/features: ' + (details ? details.value : '') + '\n';
      body += 'Preferred store: ' + store.value + '\nCustomer notes: ' + notes.value;
      quote.querySelector('[name="contact[body]"]').value = body;
    }
    function draw() {
      var subtotal = 0, quantity = 0;
      lines.innerHTML = '';
      selected.forEach(function (item, key) {
        subtotal += item.price * item.quantity; quantity += item.quantity;
        var li = document.createElement('li');
        li.className = 'pb-estimate__line';
        li.innerHTML = '<a href="' + esc(item.url) + '">' + esc(item.title) + '</a>' +
          '<small>' + esc(item.sku + ' · ' + item.location) + '</small>' +
          (item.variantTitle && item.variantTitle !== 'Default Title' ? '<small>' + esc(item.variantTitle) + '</small>' : '') +
          '<div class="pb-estimate__line-controls"><label>Qty <input type="number" min="1" max="99" step="1" value="' + item.quantity + '" aria-label="Quantity for ' + esc(item.sku + ' ' + item.location) + '" data-estimate-quantity></label><strong>' + (item.price === null ? 'Price to confirm' : money(item.price * item.quantity)) + '</strong><button type="button" data-estimate-remove aria-label="Remove ' + esc(item.sku + ' ' + item.location) + '">Remove</button></div>';
        li.querySelector('[data-estimate-quantity]').addEventListener('change', function (event) {
          var n = Number(event.target.value);
          if (busy) { event.target.value = item.quantity; return; }
          if (!Number.isInteger(n) || n < 1 || n > 99) { event.target.value = item.quantity; stateMessage('Choose a quantity from 1 to 99.'); return; }
          item.quantity = n; save(); draw();
        });
        li.querySelector('[data-estimate-remove]').addEventListener('click', function () { if (busy) return; selected.delete(key); save(); draw(); syncChecks(); });
        lines.appendChild(li);
      });
      panel.querySelector('[data-estimate-empty]').hidden = selected.size > 0;
      panel.querySelector('[data-estimate-vehicle]').textContent = validVehicle() ? activeVehicle : 'Choose your vehicle to start.';
      total.textContent = money(subtotal); count.textContent = quantity ? quantity + (quantity === 1 ? ' item' : ' items') : 'No items yet';
      var priced = Array.from(selected.values()).filter(function(item){return item.variantId && item.price !== null && !item.quoteOnly;});
      var pending = Array.from(selected.values()).filter(function(item){return !item.variantId || item.price === null || item.quoteOnly;}).length;
      cartButton.disabled = !priced.length || busy;
      if(!busy) cartButton.textContent = pending ? 'Add ' + priced.length + ' Available Items to Cart' : 'Add Selected Items to Cart';
      panel.querySelector('[data-sc-pending]').textContent = pending ? pending + ' part(s) require availability confirmation and are included in your estimate request. Only linked, available products can be added to cart.' : '';
      quoteButton.disabled = !selected.size || busy;
      panel.querySelector('[data-estimate-clear]').disabled = !selected.size || busy;
      panel.querySelectorAll('[data-estimate-quantity],[data-estimate-remove]').forEach(function (el) { el.disabled = busy; });
      root.querySelectorAll('[data-estimate-check],[data-estimate-variant]').forEach(function (el) { el.disabled = busy || el.dataset.unavailable === 'true'; });
      if (!selected.size) { quote.hidden = true; quoteButton.setAttribute('aria-expanded','false'); }
      buildQuote();
    }
    function syncChecks() {
      results.querySelectorAll('[data-estimate-key]').forEach(function (card) {
        var input = card.querySelector('[data-estimate-check]');
        if (input) input.checked = selected.has(card.dataset.estimateKey);
      });
    }
    function clearForVehicle() {
      var current = vehicle();
      if (current === activeVehicle) return;
      var hadItems = selected.size > 0;
      activeVehicle = current; selected.clear(); save(); draw(); syncChecks();
      stateMessage(hadItems ? 'Estimate cleared for your new vehicle.' : '');
    }
    function addCard(card) {
      if (card.dataset.estimateBound || !card.dataset.pbProductUrl) return;
      card.dataset.estimateBound = 'true';
      var url = card.dataset.pbProductUrl;
      var sku = (card.querySelector('.pb-result__sku') || {}).textContent || '';
      sku = sku.replace(/^Model:\s*/i,'').trim();
      var location = (card.querySelector('.pb-result__location') || {}).textContent || 'Speaker';
      var notes = (card.querySelector('.pb-result__notes') || {}).textContent || '';
      var key = [url,sku,location].join('|');
      card.dataset.estimateKey = key;
      var area = document.createElement('div'); area.className = 'pb-estimate__select';
      var label = document.createElement('label');
      var input = document.createElement('input'); input.type = 'checkbox'; input.disabled = true; input.dataset.estimateCheck = '';
      input.dataset.unavailable = 'true'; input.setAttribute('aria-label','Add ' + sku + ' for ' + location + ' to estimate');
      var caption = document.createElement('span'); caption.textContent = 'Checking availability…';
      label.append(input,caption); area.appendChild(label);
      var select = document.createElement('select'); select.hidden = true; select.dataset.estimateVariant = ''; select.setAttribute('aria-label','Choose ' + sku + ' option'); area.appendChild(select);
      card.querySelector('.pb-result__actions').prepend(area);
      var product, variant;
      function updateVariant(value) {
        variant = product.variants.find(function (v) { return String(v.id) === String(value); });
        var available = variant && variant.available && Number.isFinite(variant.price) && (!card.dataset.scReview || card.querySelector('[data-sc-review]').checked);
        input.dataset.unavailable = available ? 'false' : 'true'; input.disabled = !available || busy;
        caption.textContent = available ? 'Add to estimate · ' + money(variant.price) : variant && variant.available ? 'Check fitment notes above to select' : variant ? 'Sold out — contact us' : 'Choose an option';
        input.checked = selected.has(key);
      }
      var reviewBox = card.querySelector('[data-sc-review]');
      if (reviewBox) reviewBox.addEventListener('change', function() {if(!reviewBox.checked){selected.delete(key);save();draw();} if(variant) updateVariant(variant.id);syncChecks();});
      load(url).then(function (p) {
        if (!card.isConnected) return;
        product = p;
        var matches = product.variants.filter(function (v) { return normalize(v.sku) === normalize(sku); });
        var options = matches.length ? matches : product.variants;
        var saved = selected.get(key);
        if (options.length === 1) updateVariant(options[0].id);
        else {
          select.hidden = false;
          select.innerHTML = '<option value="">Choose an option</option>' + options.map(function (v) { return '<option value="' + esc(v.id) + '"' + (!v.available?' disabled':'') + '>' + esc(v.title) + ' · ' + money(v.price) + (!v.available?' — Sold out':'') + '</option>'; }).join('');
          if (saved && options.some(function (v) {return v.id === saved.variantId;})) select.value = saved.variantId;
          updateVariant(select.value);
          select.addEventListener('change', function () {
            selected.delete(key); updateVariant(select.value); save(); draw(); syncChecks();
          });
        }
        if (saved && (!variant || !variant.available || saved.variantId !== variant.id)) { selected.delete(key); save(); draw(); stateMessage('A saved item is no longer available. Please review your selection.'); }
      }).catch(function () {caption.textContent = 'View product to check availability';});
      input.addEventListener('change', function () {
        if (busy || !variant || !variant.available || !validVehicle()) { input.checked = false; return; }
        if (input.checked) {
          selected.set(key,{key:key,url:url,sku:sku,title:product.title,location:location,notes:notes,variantId:variant.id,variantTitle:variant.title,price:variant.price,quantity:1});
          panel.open = true;
          stateMessage(sku + ' added. Review fitment notes before ordering.');
        } else { selected.delete(key); stateMessage(sku + ' removed.'); }
        save(); draw(); syncChecks();
      });
    }
    function scan() { results.querySelectorAll('.pb-result[data-pb-product-url]').forEach(addCard); }
    root.addEventListener('sc-estimate-manual', function(event) {if(busy)return;var item=event.detail.item;if(event.detail.checked){selected.set(item.key,item);panel.open=true;}else{selected.delete(item.key);}save();draw();syncChecks();stateMessage(item.sku + (event.detail.checked?(item.price===null?' added for a price quote.':' added to your estimate. Availability to confirm.'):' removed.'));});
    root.addEventListener('sc-prices-ready',function(event){retailPrices=event.detail.prices||{};selected.forEach(function(item){if(item.quoteOnly)item.price=retailPrice(item.sku);});draw();});
    root.addEventListener('sc-results-rendered',function(){scan();syncChecks();});
    var observer = new MutationObserver(scan); observer.observe(results,{childList:true});
    [year,make,model].forEach(function (select) {select.addEventListener('change',clearForVehicle);});
    panel.querySelector('[data-estimate-clear]').addEventListener('click',function () {if (busy) return;selected.clear();save();draw();syncChecks();stateMessage('Estimate cleared.');});
    quoteButton.addEventListener('click',function () {
      quote.hidden = !quote.hidden; quoteButton.setAttribute('aria-expanded',String(!quote.hidden));
      if (!quote.hidden) { panel.open = true;buildQuote();quote.querySelector('[name="contact[name]"]').focus(); }
    });
    quote.querySelector('form').addEventListener('submit',function (event) { if (!selected.size || busy) {event.preventDefault();return;} buildQuote(); });
    cartButton.addEventListener('click',async function () {
      if (busy || !selected.size) return;
      busy = true; draw();cartButton.textContent = 'Checking your items…';stateMessage('Checking current prices and availability.');
      var snapshot = Array.from(selected.values()).filter(function(item){return item.variantId && item.price !== null && !item.quoteOnly;});
      if(!snapshot.length){busy=false;draw();return;}
      var checkoutVehicle = activeVehicle;
      var selectors = Array.from(root.querySelectorAll('[data-pb-year],[data-pb-make],[data-pb-model],[data-pb-location]'));
      var disabledStates = selectors.map(function(el) {return el.disabled;});
      selectors.forEach(function(el) {el.disabled = true;});
      try {
        var urls = Array.from(new Set(snapshot.map(function (item) {return item.url;})));
        var products = new Map(await Promise.all(urls.map(async function (url) {return [url,await load(url,true)];})));
        var invalid = [], changed = false;
        snapshot.forEach(function (item) {
          var p = products.get(item.url), v = p.variants.find(function (v) {return v.id === item.variantId;});
          if (!v || !v.available) invalid.push(item.sku);
          else if (v.price !== item.price) { item.price = v.price;changed = true; }
        });
        if (invalid.length) throw new Error('Unavailable: ' + Array.from(new Set(invalid)).join(', ') + '. Remove these items to continue.');
        if (changed) {save();stateMessage('Prices changed. Review the updated subtotal, then add your items again.');return;}
        var grouped = new Map();
        snapshot.forEach(function (item) {
          var key = String(item.variantId);
          if (!grouped.has(key)) grouped.set(key,{id:item.variantId,quantity:0,locations:[],notes:[]});
          var line = grouped.get(key);line.quantity += item.quantity;line.locations.push(item.location);if(item.notes) line.notes.push(item.notes);
        });
        var items = Array.from(grouped.values()).map(function (line) {
          return {id:line.id,quantity:line.quantity,properties:{Vehicle:checkoutVehicle,'Speaker locations':Array.from(new Set(line.locations)).join('; '),'Fitment notes':Array.from(new Set(line.notes)).join(' | ').slice(0,2000)}};
        });
        cartButton.textContent = 'Adding to cart…';
        var response = await fetch(route + 'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        var result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add all items. Review your cart before retrying.');
        stateMessage('Items added. Opening your cart…');
        snapshot.forEach(function(item){selected.delete(item.key);});save();
        window.location.assign(route + 'cart');
      } catch (error) { stateMessage(error.message || 'Unable to add items. Please try again.'); }
      finally {selectors.forEach(function(el,i) {el.disabled = disabledStates[i];});busy=false;cartButton.textContent='Add Selected Items to Cart';draw();syncChecks();}
    });
    async function restore() {
      try {
        var initialRevision = revision;
        var saved = JSON.parse(bootSavedEstimate || '{}');
        if (!validVehicle() || saved.vehicle !== activeVehicle || !Array.isArray(saved.items)) return;
        var restored = await Promise.all(saved.items.map(async function (item) {
          if (!item || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99) return null;
          if(item.quoteOnly) return Object.assign({},item,{price:retailPrice(item.sku)});
          var p = await load(item.url),v = p.variants.find(function (v) {return v.id === item.variantId && v.available;});
          if (!v || saved.vehicle !== vehicle()) return null;
          return Object.assign({},item,{price:v.price,title:p.title});
        }));
        if (saved.vehicle !== vehicle() || revision !== initialRevision) return;
        restored.filter(Boolean).forEach(function(item) {if(!selected.has(item.key)) selected.set(item.key,item);});
        if (selected.size) {panel.open=true;save();draw();syncChecks();}
      } catch (error) {}
    }
    draw();scan();restore();
    root.addEventListener('sc-vehicle-restored',restore,{once:true});
    if (quote.querySelector('[data-estimate-sent]')) {quote.hidden = false;panel.open = true;quoteButton.setAttribute('aria-expanded','true');stateMessage('Your installed estimate request has been sent.');}
  }
  function boot() {document.querySelectorAll('.sc-fitguide').forEach(init);}
  if(document.readyState !== 'complete') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
